module.exports = __webpack_public_path__ + "img/courses.600fe6ce.svg";